import {
  applyAttack,
  applyBolster,
  applyClaimInitiative,
  applyControl,
  applyDeploy,
  applyDraftPick,
  applyMove,
  applyPass,
  applyRecruit,
  applyTactic,
} from "./appliers/index";
import type { WarchestAction } from "./types/actions";
import type { ValidationResult } from "./types/common";
import type { WarchestState } from "./types/game-state";
import {
  validateAttack,
  validateBolster,
  validateClaimInitiative,
  validateControl,
  validateDeploy,
  validateDraftPick,
  validateMove,
  validatePass,
  validateRecruit,
  validateTactic,
} from "./validators/index";

export interface ReduceResult {
  readonly state: WarchestState;
  readonly validation: ValidationResult;
}

export function validateAction(
  state: WarchestState,
  action: WarchestAction,
): ValidationResult {
  switch (action.type) {
    case "DEPLOY":
      return validateDeploy(state, action);
    case "BOLSTER":
      return validateBolster(state, action);
    case "CLAIM_INITIATIVE":
      return validateClaimInitiative(state, action);
    case "RECRUIT":
      return validateRecruit(state, action);
    case "PASS":
      return validatePass(state, action);
    case "MOVE":
      return validateMove(state, action);
    case "CONTROL":
      return validateControl(state, action);
    case "ATTACK":
      return validateAttack(state, action);
    case "TACTIC":
      return validateTactic(state, action);
    case "DRAFT_PICK":
      return validateDraftPick(state, action);
  }
}

export function applyAction(
  state: WarchestState,
  action: WarchestAction,
): WarchestState {
  switch (action.type) {
    case "DEPLOY":
      return applyDeploy(state, action);
    case "BOLSTER":
      return applyBolster(state, action);
    case "CLAIM_INITIATIVE":
      return applyClaimInitiative(state, action);
    case "RECRUIT":
      return applyRecruit(state, action);
    case "PASS":
      return applyPass(state, action);
    case "MOVE":
      return applyMove(state, action);
    case "CONTROL":
      return applyControl(state, action);
    case "ATTACK":
      return applyAttack(state, action);
    case "TACTIC":
      return applyTactic(state, action);
    case "DRAFT_PICK":
      return applyDraftPick(state, action);
  }
}

export function reduceGameState(
  state: WarchestState,
  action: WarchestAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, validation };
  }
  return { state: applyAction(state, action), validation };
}
